class ContactStudio extends HTMLElement {
  connectedCallback() {
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    window.addEventListener('hashchange', this.applyHash, options);
    this.applyHash();
    const response = this.querySelector('[data-contact-success], .bps-contact__error');
    if (response) response.focus();
  }
  disconnectedCallback() { this.events?.abort(); }
  applyHash = () => {
    const topics = { business: 'Business or space consultation', feedback: 'Feedback', individual: 'Order or product question' };
    const topic = topics[location.hash.slice(1).toLowerCase()];
    const select = this.querySelector('[data-contact-topic]');
    if (!topic || !select) return;
    select.value = topic;
    // Keep existing business/feedback links working without separate duplicate forms.
    this.scrollIntoView({ block: 'start', behavior: 'instant' });
  };
}
if (!customElements.get('byms-contact-studio')) customElements.define('byms-contact-studio', ContactStudio);
